import { render, staticRenderFns } from "./PeterboroughCity.vue?vue&type=template&id=2b78744f&scoped=true&"
import script from "./PeterboroughCity.vue?vue&type=script&lang=js&"
export * from "./PeterboroughCity.vue?vue&type=script&lang=js&"
import style0 from "./PeterboroughCity.vue?vue&type=style&index=0&id=2b78744f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b78744f",
  null
  
)

export default component.exports